"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const svg_inline_react_1 = __importDefault(require("svg-inline-react"));
const useFetchSvg_1 = __importDefault(require("../../../../common/helpers/Hooks/useFetchSvg"));
const apiService_1 = __importDefault(require("../../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10vh;

  h2 {
    text-align: center;
    font-size: 2.64vmin;
    font-weight: 400;
  }

  img {
    display: block;
    margin: 0 auto;
  }

  .svg-container {
    display: block;
    margin: 0 auto;

    svg {
      height: 100%;
    }

    [stroke='#B51E15'] {
      stroke: ${props => props.theme.palette.mainAppColor.main};
      fill: ${props => props.theme.palette.mainAppColor.light};
    }

    [fill='#B51E15'] {
      stroke: ${props => props.theme.palette.mainAppColor.main};
      fill: ${props => props.theme.palette.mainAppColor.main};
    }

    [fill='#B5F0F8'] {
      fill: ${props => props.theme.palette.primary.main};
    }
  }
`;
const ButtonWrapper = styled_components_1.default.div `
  max-width: 520px;
  margin: 0 auto;
  width: 100%;

  button {
    margin-top: 2vmin;
  }
`;
const ActivateCard = ({ displayData, currentLocale, stayId, setStatusScreen, history, baseUrl }) => {
    const [progressDialog, setShowProgressDialog] = (0, react_1.useState)(false);
    const [showInternetDialogError, setShowInternetDialogError] = (0, react_1.useState)(false);
    const timeoutRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const activateCard = () => {
        let internetConnectionError = false;
        if (!navigator.onLine) {
            internetConnectionError = true;
            setShowInternetDialogError(internetConnectionError);
            return;
        }
        setShowProgressDialog(true);
        const token = localStorage.getItem('kioskUserToken');
        const stationToken = localStorage.getItem('stationToken');
        apiService_1.default
            .activateKeyCard(currentLocale, token, stayId, stationToken)
            .then((data) => {
            setStatusScreen(data);
            if (data.status === 'retry') {
                return (timeoutRef.current = setTimeout(activateCard, data.interval));
            }
            setShowProgressDialog(false);
            if (data.status === 'success') {
                if (data.screen === 'completed') {
                    history.push(`${baseUrl}/guest_journey/kiosk/keycard_activation_flow/process_completed`);
                    return;
                }
                history.push(`${baseUrl}/guest_journey/kiosk/keycard_activation_flow/activation_successfull`);
                return;
            }
            if (data.status === 'error') {
                history.push(`${baseUrl}/guest_journey/kiosk/keycard_activation_flow/activation_failed`);
            }
        })
            .catch(() => {
            setShowProgressDialog(false);
            history.push(`${baseUrl}/guest_journey/kiosk/keycard_activation_flow/activation_failed`);
        });
    };
    const loadedSvg = (0, useFetchSvg_1.default)(displayData.image);
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement("div", { className: "svg-container" }, displayData && displayData.image && react_1.default.createElement(svg_inline_react_1.default, { src: loadedSvg })),
        react_1.default.createElement("h2", null, displayData.texts ? displayData.texts.text : ''),
        react_1.default.createElement(ButtonWrapper, null,
            react_1.default.createElement(material_1.Button, { fullWidth: true, variant: "contained", size: "large", onClick: () => {
                    activateCard();
                }, "data-testid": "go-to-checkin" },
                ' ',
                displayData.texts ? displayData.texts.startActivationButton : '')),
        react_1.default.createElement(material_1.Dialog, { "data-testid": "progress-dialog", open: progressDialog, keepMounted: true, onClose: () => { }, "aria-describedby": "alert-dialog-slide-description" },
            react_1.default.createElement(material_1.DialogTitle, null, displayData.texts ? displayData.texts.activationLoadingTitle : ''),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement("p", { style: { margin: '0 0 35px 0' } }, displayData.texts ? displayData.texts.activationLoadingBody : ''),
                react_1.default.createElement(material_1.LinearProgress, null))),
        react_1.default.createElement(material_1.Dialog, { "data-testid": "internet-error", open: showInternetDialogError, keepMounted: true, onClose: () => { }, "aria-describedby": "alert-internet-connection-off " },
            react_1.default.createElement(material_1.DialogTitle, null,
                " ",
                i18n_js_1.default.t('key_cards_internet_error'),
                " "),
            react_1.default.createElement(material_1.DialogContent, null,
                " ",
                i18n_js_1.default.t('key_cards_internet_dialog_content'),
                " "),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => history.push(`${baseUrl}/guest_journey/kiosk`) },
                    " ",
                    i18n_js_1.default.t('ok'),
                    " ")))));
};
const mapStoreToProps = store => ({
    baseUrl: store.getValue('baseUrl'),
    currentLocale: store.getValue('currentLocale'),
    stayId: store.getValue('stayId'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(ActivateCard));
